<div class="auth-container">
  <div class="content">
    <div class="form-container">
      <div class="form-header">
        <img src="/assets/images/logo.png" class="form-logo" alt="logo" />
        <div class="title-wrapper">
          <h1 class="form-title">Multi-Factor Authentication</h1>
          <p class="form-desc">We sent One-Time Password to your email.</p>
          <div *ngIf="errorMessage" class="invalid">
            <svg-icon
              src="/assets/icon/icon-info.svg"
              class="icon s-12"
              aria-label="Info"></svg-icon>
            <p class="text">{{ errorMessage }}</p>
            <button
              *ngIf="errorMessage && !isResendOtp"
              type="button"
              class="clear-error"
              (click)="clearError()">
              <svg-icon
                src="/assets/icon/icon-close.svg"
                class="icon s-10"
                aria-label="Close"></svg-icon>
            </button>
          </div>
        </div>
      </div>
      <form nz-form class="form" [formGroup]="otpForm" nzLayout="vertical">
        <nz-form-item>
          <nz-form-control [nzErrorTip]="otpErrorTpl">
            <nz-form-label nzFor="otp" nzRequired
              >One-Time Password</nz-form-label
            >
            <nz-input-group nzPrefixIcon="user">
              <input
                name="otp"
                type="text"
                nz-input
                id="otp"
                formControlName="otp"
                (focus)="onInputFocus($event)"
                (keyup.enter)="otpForm.valid && signIn()"
                placeholder="Enter One-Time Password" />
              <ng-template #otpErrorTpl let-control>
                <ng-container>
                  <span *ngIf="control.hasError('required')">
                    OTP is required
                  </span>
                  <span *ngIf="control.hasError('pattern')">
                    Please enter only numbers
                  </span>
                  <span
                    *ngIf="
                      !control.hasError('pattern') &&
                      control.hasError('minlength')
                    ">
                    OTP must be at least 6 numbers
                  </span>
                  <span
                    *ngIf="
                      !control.hasError('pattern') &&
                      control.hasError('maxlength')
                    ">
                    OTP cannot exceed 6 numbers
                  </span>
                </ng-container>
              </ng-template>
            </nz-input-group>
          </nz-form-control>
        </nz-form-item>
        <div nz-row class="remember-me">
          <div class="left text-clr" *ngIf="!isExpired">
            OTP will expire in {{ timeRemaining | secondsToTime }} seconds.
            Please do not refresh or leave the page.
          </div>
          &nbsp;
          <div class="right">
            <button
              type="button"
              class="login-form-forgot"
              (click)="resendOtp()"
              [disabled]="
                isResendOtp || (!isExpired && !isOtpAlreadyGenerated)
              ">
              {{ isResendOtp ? 'Sending...' : 'Resend OTP' }}
            </button>
          </div>
        </div>
        <button
          type="button"
          nz-button
          type="button"
          [disabled]="otpForm.invalid"
          [nzLoading]="isLoading"
          class="form-button"
          [nzType]="'primary'"
          (click)="signIn()">
          Submit
        </button>
      </form>
      <a
        class="back-link"
        href="/login"
        *ngIf="!router.url.includes('/verify-user')">
        <svg-icon
          src="/assets/icon/icon-arrow.svg"
          class="icon s-12"
          aria-label="Arrow">
        </svg-icon>
        Back to Log In
      </a>
    </div>
  </div>
</div>
